/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_PrimaryStockExchangeDto } from '../models/PagedResultDto_PrimaryStockExchangeDto';
import type { Wealthlane_CustomerService_Dtos_PrimaryStockExchange_CreateUpdatePrimaryStockExchangeDto } from '../models/Wealthlane_CustomerService_Dtos_PrimaryStockExchange_CreateUpdatePrimaryStockExchangeDto';
import type { Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto } from '../models/Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PrimaryStockExchangeService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppPrimaryStockExchangePrimaryStockExchangeList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/primary-stock-exchange/primary-stock-exchange-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppPrimaryStockExchange(
requestBody?: Wealthlane_CustomerService_Dtos_PrimaryStockExchange_CreateUpdatePrimaryStockExchangeDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/primary-stock-exchange',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PrimaryStockExchangeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppPrimaryStockExchange(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PrimaryStockExchangeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/primary-stock-exchange',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppPrimaryStockExchange(
id: string,
requestBody?: Wealthlane_CustomerService_Dtos_PrimaryStockExchange_CreateUpdatePrimaryStockExchangeDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/primary-stock-exchange/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppPrimaryStockExchange(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/primary-stock-exchange/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppPrimaryStockExchange1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_PrimaryStockExchange_PrimaryStockExchangeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/primary-stock-exchange/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
